import { Checkbox, TableCell } from "@mui/material";

export default function SelectionCheckboxCell({
  checked,
  indeterminate,
  onChange,
  disabled,
  hidden,
  stopClickPropagation,
}) {
  const styles = {
    cell: { width: 48, px: 1 },
  };

  return (
    <TableCell
      padding="checkbox"
      sx={styles.cell}
      onClick={stopClickPropagation ? (e) => e.stopPropagation() : undefined}
    >
      {!hidden && (
        <Checkbox
          checked={checked}
          indeterminate={indeterminate}
          onChange={onChange}
          disabled={disabled}
        />
      )}
    </TableCell>
  );
}
